import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { FaEllipsisV, FaDownload, FaFileAlt, FaMoneyBillWave ,FaPaperPlane} from 'react-icons/fa';
import Modal from 'react-modal';
import { getAllAnnonceByUser } from '../../services/Annonce_service';
import { Annonce } from '../../models/AnnonceModel';
import LoaderAnnonce from '../../components/LoaderAnnonce';
import AnnonceDetail from './detailAnnonce';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import useAppContext from '../../hooks/useAppContext';
import { AppContextType } from '../../context/AppContext';
import { additiveNSType, correctiveNSType } from '../../constant/announcementType';
import '../../css/tableauAnnonce.css';
import { Badge, Button, Popover } from 'antd';
import AnnouncementStatus from '../../components/announcement-management/AnnouncementStatus';
import {
  sendAttestationAloByEmail,
  sendJustifByEmail,
} from '../../services/Mail_service';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import SaisirAdditif from './SaisirAdditif';
import { getUserDetails } from '../../services/User_service';
import CreditNote from './avoir/CreditNote';
import { paginate, ITEMS_PER_PAGE } from '../../utils/functions/pagination';
import { PaginationControls } from '../../components/PaginationControls';
import { PointsSettings } from '../../models/PointsSettings';
import { getPointsSettings } from '../../services/pointsService';
import { DatePicker } from "antd";
import dayjs from "dayjs";
import EmailReminderModal from '../../components/gestion-annonce/EmailReminderModal';

function GestionAnnonce() {
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const {
    announcementTypeList,
    setCurrentAnnoucement,
    setSelectedType,
    setActiveIndex,
    setCheckedIndex,
    setUserAnnonces,
    clearContext,
    setUserPoints
  } = useAppContext() as AppContextType

  const [annonces, setAnnonces] = useState<Annonce[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [searchText, setSearchText] = useState<string>('');
  const [searchSupport, setSearchSupport] = useState<string>('');
  const [searchReference, setSearchReference] = useState<string>('');
  const [annonceNow, setAnnonceNow] = useState<Annonce | null>(null);
  const [saisirNow, setSaisirNow] = useState<Annonce | null>(null);
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [showMenu, setShowMenu] = useState<number | null>(null);
  const [modalType, setModalType] = useState<'Télécharger' | 'additif' | null>(null);
  const stored = localStorage.getItem('userProfile');
  const userEmail = stored ? JSON.parse(stored).email : '';
  const [pointsSettings, setPointsSettings] = useState<PointsSettings>({ multiplier: 0, point_value: 0 })
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') === 'avoirs' ? 'avoirs' : 'annonces';
  const [activeTab, setActiveTab] = useState<"annonces" | "avoirs">(initialTab);

  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ currentAnnonce, setCurrentAnnonce ] = useState< Annonce | null >( null )

  const [isTodayFilterActive, setIsTodayFilterActive] = useState<boolean>(false);

  useEffect(() => {
    const getPointsEstting = async () => {
      const tempPointsSettings = await getPointsSettings()
      setPointsSettings(tempPointsSettings)
      console.log('tempPointsSettings', tempPointsSettings)
    }

    getPointsEstting()
  }, [])

  const [confirmModal, setConfirmModal] = useState<{
    annonce: Annonce | undefined;
    type: undefined | "justif" | "alo";
    isOpen: boolean;
    loading: boolean;
    email: string;
  }>({
    annonce: undefined,
    type: undefined,
    isOpen: false,
    loading: false,
    email: "",
  });


  const hasVerified = useRef(false);
  const Navigate = useNavigate()
  const menuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {

    // === Récupération du solde de points utilisateur ===
    const getUserPoints = async () => {
      const user = await getUserDetails();
      if (user && user.points_balance !== undefined) {
        setUserPoints(user.points_balance); // ← solde actuel de l'utilisateur
      }
    }

    getUserPoints()

  }, [])

  // Handlers pour les actions de modal de confirmation
  const handleClickSendAttestation = (annonce: Annonce) => {
    setConfirmModal((prev) => ({
      ...prev,
      type: "alo",
      annonce,
      isOpen: true,
      email: annonce.email || userEmail,
    }));
  };

  const handleClickSendJustif = (annonce: Annonce) => {
    setConfirmModal((prev) => ({
      ...prev,
      type: "justif",
      annonce,
      isOpen: true,
      email: annonce.email || userEmail,
    }));
  };

  const handleClickReminder = ( annonce: Annonce ) => {
    setCurrentAnnonce( annonce )
    setIsModalOpen( true )
  }

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmModal((prev) => ({
      ...prev,
      email: e.target.value,
    }));
  };

  const handleConfirmLegale = async () => {
    setConfirmModal((prev) => ({ ...prev, type: "alo", loading: true }));
    try {
      const response = await sendAttestationAloByEmail({
        email: confirmModal.email,
        attestationAlo: confirmModal.annonce?.pdfAttestation.split("-").join("-ALO-"),
      });
      setConfirmModal((prev) => ({
        ...prev,
        type: "alo",
        isOpen: false,
        loading: false,
      }));
      toast.success(response?.message);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setConfirmModal((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleConfirmJustif = async () => {
    setConfirmModal((prev) => ({ ...prev, type: "justif", loading: true }));
    try {
      const annonceId = confirmModal.annonce?.annonce_id || confirmModal.annonce?.id;
      if (!confirmModal.email || !annonceId) {
        throw new Error("L'email et l'annonce à envoyer est obligatoire");
      }
      const response = await sendJustifByEmail({
        email: confirmModal.email,
        annonceId,
      });
      setConfirmModal((prev) => ({
        ...prev,
        type: "justif",
        isOpen: false,
        loading: false,
      }));
      toast.success(response?.message);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setConfirmModal((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleCloseConfirmModal = () => {
    if (!confirmModal.loading) {
      setConfirmModal((prev) => ({
        ...prev,
        isOpen: false,
        email: "",
      }));
    }
  };
  
  useLayoutEffect(() => {

    const loadAnnoncesWithPoints = async () => {
      setLoading(true);
      await fetchAnnonces();
      setLoading(false);
    };

      loadAnnoncesWithPoints();

    hasVerified.current = true;
  }, [searchParams]);

  const handleAnnonceDetail = (annonce: Annonce) => {
    setAnnonceNow(annonce);
    setModalType('Télécharger');
    setModalIsOpen(true);
  };

  const handleSaisirAdditif = (annonce: Annonce) => {
    clearContext()
    setCurrentAnnoucement(annonce)
    const tempAnnonceType = announcementTypeList.find(item => item.nSType === additiveNSType)
    if (tempAnnonceType) { setSelectedType(tempAnnonceType) }
    setActiveIndex(1)
    setCheckedIndex(1)
    Navigate('/home/nouvell-annonce')
  };

  const handleSaisirRectificatif = (annonce: Annonce) => {
    clearContext()
    setCurrentAnnoucement(annonce)
    const tempAnnonceType = announcementTypeList.find(item => item.nSType === correctiveNSType)
    if (tempAnnonceType) { setSelectedType(tempAnnonceType) }
    setActiveIndex(1)
    setCheckedIndex(1)
    Navigate('/home/nouvell-annonce')
  };

  // Fonction pour récupérer les annonces
  const fetchAnnonces = async () => {
    setLoading(true);
    try {
      const fetchedAnnonces = await getAllAnnonceByUser();
      if (fetchedAnnonces) {
        console.log('Fetched annonces:', fetchedAnnonces.map(annonce => ({
          id: annonce.id,
          reminderCount: annonce.reminderCount,
          lastReminderDate: annonce.lastReminderDate
        })));
        setAnnonces(fetchedAnnonces.filter((annonce: Annonce) => annonce.status !== 3));
        setUserAnnonces(fetchedAnnonces.filter((annonce: Annonce) => annonce.status !== 3));
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des annonces:", error);
    }
    setLoading(false);
  };

  // UseEffect pour gérer les clics extérieurs
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setShowMenu(null);
      }
    };
    if (showMenu !== null) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu]);

  // Handlers pour les champs de recherche
  const handleSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  const handleSearchSupportChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchSupport(e.target.value);
  };

  const handleSearchReferenceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchReference(e.target.value);
  };

  // Utilitaires
  const formatedDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${day}/${month}/${year}`;
  };

  const toggleMenu = (index: number) => {
    setShowMenu(index === showMenu ? null : index);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
    setAnnonceNow(null);
    setSaisirNow(null);
    setModalType(null);
  };

  // Filtrage des annonces
  const filteredAnnonces = annonces.filter((annonce) => {
    const searchTextLower = searchText.toLowerCase();
    const searchSupportLower = searchSupport.toLowerCase();
    const searchReferenceLower = searchReference.toLowerCase();
    const dossierAnnonceMatch = (
      annonce.numDossier.toLowerCase().includes(searchTextLower) ||
      annonce.numAnnonce.toLowerCase().includes(searchTextLower) ||
      annonce.denomination.toLowerCase().includes(searchTextLower) 

    );
    const supportMatch = annonce.nomJal.toLowerCase().includes(searchSupportLower);
    const referenceMatch = (
      annonce.numAnnonce.toLowerCase().includes(searchReferenceLower) ||
      annonce.numDossier.toLowerCase().includes(searchReferenceLower)
    );

    // Filtrage par date
    const annonceDateObj = new Date(annonce.createdAt);
    if (isNaN(annonceDateObj.getTime())) return false; // si date invalide, ignore

    let start: Date | null = null;
    let end: Date | null = null;

    if (startDate) {
      const tempStart = new Date(startDate);
      if (!isNaN(tempStart.getTime())) {
        start = tempStart;
        start.setHours(0, 0, 0, 0);
      }
    }

    if (endDate) {
      const tempEnd = new Date(endDate);
      if (!isNaN(tempEnd.getTime())) {
        end = tempEnd;
        end.setHours(23, 59, 59, 999);
      }
    }

    const annonceTime = annonceDateObj.getTime();
    const dateMatch =
      (!start || annonceTime >= start.getTime()) &&
      (!end || annonceTime <= end.getTime());

    return dossierAnnonceMatch && supportMatch && referenceMatch && dateMatch;
  });

  // Affichage du loader
  if (loading) {
    return <><ToastContainer /> <LoaderAnnonce /> </>;
  }

  const { paginatedData: paginatedAnnonces, totalPages } = paginate(
    filteredAnnonces.sort((a, b) => b.id - a.id),
    currentPage,
    ITEMS_PER_PAGE
  );

  function updateEntete() { }
  function updateFloid() { }
  function updateTextAnnonce() { }

  const handleCloseDetail = () => {
    setModalIsOpen(false);
    setAnnonceNow(null);
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const todayEnd = new Date(today);
  todayEnd.setHours(23, 59, 59, 999);

  const annoncesDuJour = filteredAnnonces.filter((annonce) => {
    const annonceDate = new
      Date(annonce.createdAt);
    return annonceDate >= today && annonceDate <= todayEnd;
  });

  // Contenu du menu d'actions
  const menuContent = (annonce: Annonce) => (
    <div>
      <button
        className="dropdown-item btn btn-sm"
        style={{ borderRadius: 5, padding: '3px 10px' }}
        onClick={() => handleSaisirRectificatif(annonce)}
      >
        Saisir un rectificatif
      </button>
      <button
        className="dropdown-item btn btn-sm"
        style={{ borderRadius: 5, padding: '3px 10px' }}
        onClick={() => handleSaisirAdditif(annonce)}
      >
        Saisir un additif
      </button>
      <button
        className="dropdown-item btn btn-sm"
        style={{ borderRadius: 5, padding: '3px 10px' }}
        onClick={() => handleClickSendAttestation(annonce)}
      >
        Envoyer l'attestation legale
      </button>
      {annonce?.pdf_justif_lien_public && annonce?.isPaid && (
        <button
          className="dropdown-item btn btn-sm"
          style={{ borderRadius: 5, padding: '3px 10px' }}
          onClick={() => handleClickSendJustif(annonce)}
        >
          Envoyer le fichier PDF Justificatif
        </button>
      )}
    </div>
  )

  return (
    <>
      <ToastContainer />

      <EmailReminderModal
        isModalOpen = { isModalOpen }
        setIsModalOpen = { setIsModalOpen }
        currentAnnonce = { currentAnnonce }
        setCurrentAnnonce = { setCurrentAnnonce }
        onReminderSent = { fetchAnnonces }
      />

      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "annonces" ? "active" : ""}`}
            onClick={() => setActiveTab("annonces")}
            role="button"
          >
            <FaFileAlt className="me-2" /> Mes Annonces
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "avoirs" ? "active" : ""}`}
            onClick={() => setActiveTab("avoirs")}
            role="button"
          >
            <FaMoneyBillWave className="me-2" /> Mes Avoirs
          </a>
        </li>
      </ul>

      {
        activeTab === "avoirs" ?
          <CreditNote />
          :
          <>

            <div
              className="mb-3 d-flex align-items-center gap-3"
              style={{ justifyContent: "flex-start" }}
            >
              <span
                className="badge"
                style={{
                  padding: "15px",
                  fontSize: "15px",
                  backgroundColor: "#F4A261"
                }}
              >
                Nombre d'annonces | {filteredAnnonces.length}
              </span>
              <span
                className="badge"
                style={{
                  padding: "15px",
                  fontSize: "15px",
                  backgroundColor: "#4BB0C0"
                }}
              >
                Annonces du jour | {annoncesDuJour.length}
              </span>
              <span
                className="badge"
                style={{
                  backgroundColor: isTodayFilterActive ? "#4BB0c0" : "#ffffff14",
                  color: isTodayFilterActive ? "#fff" : "#000",
                  border: "1px solid #4BB0c0",
                  padding: "15px",
                  fontSize: "15px",
                  transform: "scale(1)",
                }}
                onClick={() => {
                  if (!isTodayFilterActive) {
                    const yyyy = today.getFullYear();
                    const mm = String(today.getMonth() + 1).padStart(2, "0");
                    const dd = String(today.getDate()).padStart(2, "0");
                    const formattedDate = `${yyyy}-${mm}-${dd}`;
                    setStartDate(formattedDate);
                    setIsTodayFilterActive(true);
                  } else {
                    setStartDate("");
                    setEndDate("");
                    setIsTodayFilterActive(false);
                  }
                }}
              >
                {
                  isTodayFilterActive ? "Voir toutes les annonces" : "Afficher les annonces du jour"
                }
              </span>
            </div>
            <div className="gestion-annonce container-fluid px-3">
              <div className="row align-items-center mb-3">
                <div className="col-12">
                  <div className="gestion-annonce-search-container d-flex flex-wrap gap-3 mb-3">
                    <div className="gestion-annonce-search-group flex-fill" style={{ minWidth: '150px' }}>
                      <label htmlFor="start-date" className="form-label small">Date début</label>
                      <DatePicker
                        style={{ width: '100%' }}
                        id="start-date"
                        value={startDate ? dayjs(startDate) : null}
                        onChange={(date) => setStartDate(date ? date.format("YYYY-MM-DD") : null)}
                      />
                    </div>

                    <div className="gestion-annonce-search-group flex-fill" style={{ minWidth: '150px' }}>
                      <label htmlFor="end-date" className="form-label small">Date fin</label>
                      <DatePicker
                        style={{ width: '100%' }}
                        id="end-date"
                        value={endDate ? dayjs(endDate) : null}
                        onChange={(date) => setEndDate(date ? date.format("YYYY-MM-DD") : null)}
                      />
                    </div>
                    <div className="gestion-annonce-search-group flex-fill" style={{ minWidth: '200px' }}>
                      <label htmlFor="search-dossier-annonce" className="form-label small">Recherche par dossier ou annonce</label>
                      <input
                        id="search-dossier-annonce"
                        type="text"
                        className="form-control form-control-sm"
                        value={searchText}
                        onChange={handleSearchTextChange}
                      />
                    </div>
                    <div className="gestion-annonce-search-group flex-fill" style={{ minWidth: '150px' }}>
                      <label htmlFor="search-support" className="form-label small">Recherche par support</label>
                      <input
                        id="search-support"
                        type="text"
                        className="form-control form-control-sm"
                        value={searchSupport}
                        onChange={handleSearchSupportChange}
                      />
                    </div>
                    <div className="gestion-annonce-search-group flex-fill" style={{ minWidth: '150px' }}>
                      <label htmlFor="search-reference" className="form-label small">Recherche par référence client</label>
                      <input
                        id="search-reference"
                        type="text"
                        className="form-control form-control-sm"
                        value={searchReference}
                        onChange={handleSearchReferenceChange}
                      />
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div className="gestion-annonce-table">
              <div className="table-container">
                <table className="table-annonce-user">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Référence</th>
                      <th>Annonce</th>
                      <th>Type</th>
                      <th>Montant</th>
                      <th>Support</th>
                      <th>Parution</th>
                      <th style={{ textAlign: 'center' }}>PDF</th>
                      <th style={{ textAlign: 'center' }}>Status</th>
                      <th style={{ textAlign: 'center' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedAnnonces
                      .sort((a, b) => b.id - a.id)
                      .map((annonce: Annonce, index) => {
                        console.log(`Annonce ${annonce.id}: reminderCount=${annonce.reminderCount}, lastReminderDate=${annonce.lastReminderDate}`);
                        return (
                          <tr key={index}>
                            <td className="small">{formatedDate(new Date(annonce.createdAt))}</td>
                            <td className="small">
                              <div className="text-truncate" style={{ maxWidth: '120px', fontSize: '0.9em' }} title={annonce.numAnnonce}>
                                {annonce.numAnnonce}
                              </div>
                              <div className="text-muted text-truncate" style={{ maxWidth: '120px', fontSize: '1em' }} title={annonce.numDossier}>
                                {annonce.numDossier}
                              </div>
                            </td>
                            <td>
                              <div className="text-truncate" style={{ maxWidth: '150px' }} title={annonce.denomination}>
                                {annonce.denomination}
                              </div>
                            </td>
                            <td>
                              <div className="text-truncate small" style={{ maxWidth: '100px', fontSize: '1em' }} title={annonce.type_annonce}>
                                {annonce.type_annonce}
                              </div>
                            </td>
                            <td className="small gestion-annonce-montant-section">

                              <div style={{ fontWeight: 'bold' }}>

                                {Number(annonce.montantTTC).toFixed(2)} € TTC

                                <AnnouncementStatus annonce={annonce} />
                                {
                                  (annonce.usedPoints && annonce.usedPoints > 0)
                                    ?
                                    <div style={{ color: "#ff9e28ff", fontSize: "0.9em", lineHeight: "1em" }}>
                                      - Remise de points de : {Number(annonce?.usedPoints * pointsSettings?.point_value).toFixed(2)} &nbsp; €
                                    </div>
                                    : null
                                }
                              </div>
                            </td>
                            <td>
                              <div className="text-truncate small" style={{ maxWidth: '120px', fontSize: '0.9em' }} title={annonce.nomJal}>
                                {annonce.nomJal}
                              </div>
                            </td>
                            <td className="small" style={{ fontSize: '0.9em' }}>
                              {formatedDate(new Date(annonce.dateParrution))}
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              <FaDownload
                                size={16}
                                color="#F4A261"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleAnnonceDetail(annonce)}
                                title="Télécharger les documents"
                              />
                            </td>
                            <td style={{ textAlign: 'center', padding: '8px 6px' }}>
                                {
                                  !annonce.isPaid
                                  ?
                                    <Popover content = "Relancer la facturation" trigger="hover">
                                      <Button
                                        onClick={() => handleClickReminder(annonce)}
                                        style={{
                                          background: '#F4A261',
                                          border: 'none',
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          padding: '10px 15px',
                                          height:'auto',
                                          width: '100%',
                                          boxSizing: 'border-box',
                                          whiteSpace: 'normal',
                                          borderRadius: 6
                                        }}
                                      >
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, flex: 1 }}>
                                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
                                            {(annonce?.reminderCount ?? 0) > 0 && (
                                              <span
                                                style={{
                                                  backgroundColor: '#fff',
                                                  color: '#F4A261',
                                                  borderRadius: '50%',
                                                  width: 20,
                                                  height: 20,
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  justifyContent: 'center',
                                                  fontSize: 11,
                                                  fontWeight: 'bold',
                                                  flexShrink: 0
                                                }}
                                                title={`${annonce.reminderCount ?? 0} relance(s) envoyée(s)`}
                                              >
                                                {annonce.reminderCount}
                                              </span>
                                            )}

                                            <span style={{ color: '#FFF', fontWeight: 'bold', fontSize: 14 }}>Non payé</span>
                                          </div>

                                          { (annonce?.reminderCount ?? 0) > 0 && annonce.lastReminderDate && (
                                            <span style={{ fontSize: 15, color: '#FFF', opacity: 0.9, textAlign: 'center', lineHeight: 1.2 }}
                                              title={`Dernière relance : ${new Date(annonce.lastReminderDate).toLocaleString('fr-FR')}`}>
                                              {new Date(annonce.lastReminderDate).toLocaleDateString('fr-FR')} 
                                            </span>
                                          )}
                                        </div>

                                        <FaPaperPlane style={{ color: 'white', marginLeft: 8, flexShrink: 0 }} />
                                      </Button>
                                    </Popover>
                                  :
                                    <Badge count = 'Payé' showZero color="#5bc1d1" />
                                }
                            </td>

                            {/* <td className="gestion-annonce-menu-container position-relative text-center"> */}
                              <td style={{ textAlign: 'center', padding: '8px 6px' }}>
                              <Popover content={menuContent(annonce)} trigger="click">
                                <Button onClick={() => toggleMenu(index)}
                                  className='gestion-annonce-menu-button'>
                                  <FaEllipsisV size={12} />
                                </Button>
                              </Popover>
                            </td>

                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
              {totalPages > 1 && (
                <div className="d-flex justify-content-center align-items-center gap-2 mt-3">
                  <PaginationControls
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                  />
                </div>
              )}
            </div>
          </>
      }
      {
        filteredAnnonces.length === 0 && (
          <div className="text-center py-4">
            <p className="text-muted">Aucune annonce trouvée</p>
          </div>
        )
      }

      {
        modalIsOpen && modalType === 'Télécharger' && annonceNow && (
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={handleCloseModal}
            contentLabel="Annonce Detail"
            overlayClassName="modal-overlay"
            className="modal-content la-announcement-detail-modal"
            style={{
              content: {
                zIndex: '9999',
                padding: '0 0 0 0',
                width: '1000px',
              }
            }}
          >
            <AnnonceDetail annonceNow={annonceNow} closeModal={handleCloseModal} />

            <div style={{ display: "flex", justifyContent: "center", background: "#fff", marginBottom: "-25px" }}>
              <button type="button"
                className="btn btn-secondary"
                onClick={handleCloseDetail}
                style={{ backgroundColor: '#F4A261', border: 'none', marginTop: '10px', marginBottom: '30px' }}
              >
                Fermer
              </button>
            </div>
          </Modal>
        )
      }

      {
        modalIsOpen && modalType === 'additif' && saisirNow && (
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={handleCloseModal}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
            contentLabel="Saisir Additif"
            className="ant-popover-inner-content"
          >
            <SaisirAdditif
              annonceNow={saisirNow}
              closeModal={handleCloseModal}
              entete={''}
              updateEntete={updateEntete}
              floid={''}
              updateFloid={updateFloid}
              updateTextAnnonce={updateTextAnnonce}
            />
            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '-38px', marginLeft: '250px' }}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCloseModal}
                style={{ backgroundColor: '#F4A261', border: 'none' }}
              >
                Fermer
              </button>
            </div>
          </Modal>
        )
      }

<Modal
  isOpen={
    Boolean(confirmModal.annonce) &&
    Boolean(confirmModal.type) &&
    confirmModal.isOpen
  }
  onRequestClose={() => { }}
  shouldCloseOnOverlayClick={false}
  shouldCloseOnEsc={false}
  contentLabel="Confirmation Email"
  overlayClassName="modal-overlay"
  className="modal-content"
  style={{
    content: {
      maxWidth: "500px",
      maxHeight: "400px",
      padding: "0",
      border: "none",
      borderRadius: "8px",
      backgroundColor: "white",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)", 
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    overlay: {
      backgroundColor: "rgba(0,0,0,0.5)", 
      zIndex: 1000,
    },
  }}
>
        <div className="d-flex justify-content-between align-items-center p-3">
          <h5 className="modal-title mb-0">
            {`Confirmation de l'envoi ${confirmModal.type === "alo"
              ? "de l'attestation legale"
              : "du pdf justificatif"
              }`}
          </h5>
          <button
            type="button"
            className="btn-close border-0 bg-transparent"
            onClick={handleCloseConfirmModal}
            disabled={confirmModal.loading}
            aria-label="Fermer"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="p-3">
          <p className="mb-3">
            Vous voulez envoyer{" "}
            {confirmModal.type === "alo"
              ? "l'attestation de ALO"
              : "le pdf justificatif"}{" "}
            ?
          </p>

          <div className="mb-3">
            <label htmlFor="email-input" className="form-label">
              Adresse email :
            </label>
            <input
              id="email-input"
              type="email"
              className="form-control"
              value={confirmModal.email}
              onChange={handleEmailChange}
              disabled={confirmModal.loading}
              placeholder="Entrez l'adresse email"
            />
          </div>
        </div>

        <div className="d-flex justify-content-end gap-2 p-3">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleCloseConfirmModal}
            disabled={confirmModal.loading}
          >
            Annuler
          </button>
          <button
            type="button"
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={() =>
              confirmModal.type === "alo"
                ? handleConfirmLegale()
                : handleConfirmJustif()
            }
            disabled={confirmModal.loading || !confirmModal.email.trim()}
            style={{ backgroundColor: "#F4A261", border: "none" }}
          >
            {confirmModal.loading ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Envoi...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faEnvelope} />
                Confirmer
              </>
            )}
          </button>
        </div>
      </Modal>

    </>
  );
}

export default GestionAnnonce;